import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-facts/jb-ref-facts.ts
import { awaitForEach, isPartiallyInViewPort } from "@bjb/bjb-web-components/dist/assets/scripts/JB";
import "@bjb/bjb-web-components/dist/components/jb-richtext/jb-richtext";
import { jbLinkClickedEventToJbTrackingEvent, Spaceable } from "@bjb/bjb-web-components/dist/mixins";
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property, query, queryAll } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import Masonry from "masonry-layout";

// src/components/jb-ref-facts/jb-ref-facts.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_facts_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.title {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

h2 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h2 {
  font-size: var(--theme-typo-h2-subtitle-mobile-fontsize, 1.625rem);
  font-weight: var(--theme-typo-h2-subtitle-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-h2-subtitle-mobile-lineheight, 2.188rem);
}

@media (min-width: 1281px) {
  h2 {
    font-size: var(--theme-typo-h2-subtitle-desktop-fontsize, 1.938rem);
    line-height: var(--theme-typo-h2-subtitle-desktop-lineheight, 2.625rem);
  }
}
.title {
  font-size: var(--theme-typo-p-highlight-mobile-fontsize, 1.063rem);
  font-weight: var(--theme-typo-p-highlight-fontweight, var(--theme-font-bold-weight, 700));
  line-height: var(--theme-typo-p-highlight-mobile-lineheight, 1.875rem);
}

@media (min-width: 1281px) {
  .title {
    font-size: var(--theme-typo-p-highlight-desktop-fontsize, 1.188rem);
    line-height: var(--theme-typo-p-highlight-desktop-lineheight, 2.125rem);
  }
}
.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

:host {
  display: block;
  --text-opacity: 1;
}

h2 {
  margin-bottom: 28px;
}
@media (min-width: 1281px) {
  h2 {
    margin-bottom: 36px;
  }
}

header,
.container {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.container.grid {
  display: block;
}
@media (min-width: 600px) {
  .container.grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1281px) {
  .container.grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 960px) {
  .facts--2-cols .container {
    margin-inline: -20px;
  }
}
@media (min-width: 960px) {
  .facts--2-cols .element {
    box-sizing: border-box;
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 20px;
    width: 50%;
  }
}

@media (min-width: 960px) {
  .facts--3-cols .container {
    margin-inline: -var(--theme-spacing-sm);
  }
}
@media (min-width: 1281px) {
  .facts--3-cols h2 {
    margin-left: 8.3333333333%;
    padding-inline-start: 16px;
  }
}
@media (min-width: 960px) {
  .facts--3-cols .element {
    box-sizing: border-box;
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    padding: 0 20px;
    width: 33.3333333333%;
  }
}

.fact {
  margin-bottom: 32px;
}

.title-bar {
  background-color: #141e55;
  float: left;
  height: auto;
  max-height: 0;
  opacity: 0;
  position: relative;
  top: 7px;
  transition: max-height 1.32s cubic-bezier(0.83, 1.49, 0.64, 1), opacity 0.66s ease-in;
  width: 1px;
}
.fact.show .title-bar {
  height: 56px;
  max-height: 56px;
  opacity: 0.2;
}

.content {
  margin-left: 23px;
  opacity: 0;
  padding-right: 16px;
  transform: translateY(-50px);
  transition: transform 1.32s cubic-bezier(0.83, 1.49, 0.64, 1), opacity 0.66s ease-in 0.66s;
}
.fact.show .content {
  opacity: 1;
  transform: translateY(0);
}

.title {
  color: #141e55;
  margin-block: 0;
  padding-bottom: 2px;
}`;

// src/components/jb-ref-facts/jb-ref-facts.ts
var JbRefFacts = class extends Spaceable(LitElement) {
  constructor() {
    super(...arguments);
    this.layout = "masonry";
    this._masonry = void 0;
  }
  update(changedProperties) {
    super.update(changedProperties);
    this._remasonry();
  }
  firstUpdated() {
    this._bindEvents();
    this._loadMasonry();
    setTimeout(() => {
      this._remasonry();
      this._fadeInIfInViewport(this);
    }, 0);
  }
  _bindEvents() {
    const element = this;
    document.addEventListener("scroll", () => {
      this._fadeInIfInViewport(element);
    });
    window.addEventListener("resize", this._remasonry);
  }
  _fadeInIfInViewport(element) {
    if (isPartiallyInViewPort(element, 20)) {
      this._startFadeInAnimation().then();
    }
  }
  _getContentSpacingProperties() {
    const cols = { 1: 8, 2: 8, 3: 8 }[this.columns] || 8;
    const align = "center";
    const type = "focus";
    return { align, colsMdUp: cols, type };
  }
  _loadMasonry() {
    if (!this._container || this.layout !== "masonry") return;
    this._masonry = new Masonry(this._container, {
      itemSelector: ".element",
      columnWidth: ".element",
      horizontalOrder: true,
      percentPosition: true,
      transitionDuration: 0,
      stagger: 0,
      resize: true
    });
  }
  _remasonry() {
    if (this._masonry?.layout) {
      this._masonry.layout();
    }
  }
  async _startFadeInAnimation() {
    setTimeout(async () => {
      await awaitForEach(this._facts, async (fact) => {
        fact.classList.add("show");
        await new Promise((p) => setTimeout(p, 50));
      });
      this._remasonry();
    }, 0);
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "facts"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return html`
      <section class="facts--${this.columns}-cols">
        ${this.headline ? html`<header><h2>${this.headline}</h2></header>` : nothing}
        <div class="container ${this.layout}">
          ${this.items.map(
      (item) => html`
              <div class="element">
                <div class="fact">
                  <div class="title-bar"></div>
                  <div class="content">
                    <p class="title">${item.title}</p>
                    <div class="text">
                      <jb-richtext
                        @jb-link:clicked=${this._tracking}
                        .size=${"small"}
                        >${unsafeHTML(item.content)}</jb-richtext
                      >
                    </div>
                  </div>
                </div>
              </div>
            `
    )}
        </div>
      </section>
    `;
  }
};
JbRefFacts.styles = unsafeCSS(jb_ref_facts_default);
__decorateClass([
  property({ type: Number })
], JbRefFacts.prototype, "columns", 2);
__decorateClass([
  property()
], JbRefFacts.prototype, "headline", 2);
__decorateClass([
  property({ type: Array })
], JbRefFacts.prototype, "items", 2);
__decorateClass([
  property({ type: String })
], JbRefFacts.prototype, "layout", 2);
__decorateClass([
  query(".container")
], JbRefFacts.prototype, "_container", 2);
__decorateClass([
  queryAll(".fact")
], JbRefFacts.prototype, "_facts", 2);
JbRefFacts = __decorateClass([
  customElement("jb-ref-facts")
], JbRefFacts);

export {
  JbRefFacts
};
